import React from "react";
import { motion } from "framer-motion";
import { useLocation } from "react-router-dom";

const EASE = [0.16, 1, 0.3, 1];

export default function SheetTransition({ children }) {
  const location = useLocation();
  const reduce = typeof window !== "undefined" && window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  if (reduce) return <>{children}</>;

  return (
    <motion.div
      key={location.pathname}
      initial={{ y: 24, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: -24, opacity: 0 }}
      transition={{ duration: 0.55, ease: EASE }}
    >
      {children}
    </motion.div>
  );
}
